import { render, staticRenderFns } from "./EPGProvider.vue?vue&type=template&id=7b1948f8&scoped=true&"
import script from "./EPGProvider.vue?vue&type=script&lang=js&"
export * from "./EPGProvider.vue?vue&type=script&lang=js&"
import style0 from "./EPGProvider.vue?vue&type=style&index=0&id=7b1948f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1948f8",
  null
  
)

export default component.exports